import { getEnvVars } from '@e-socna/utils';

import type { EnvVars } from './types/env-vars.type';

const environment = getEnvVars<EnvVars>();

export { environment };
